import { render, staticRenderFns } from "./memberedit.vue?vue&type=template&id=a8996104&scoped=true&"
import script from "./memberedit.vue?vue&type=script&lang=js&"
export * from "./memberedit.vue?vue&type=script&lang=js&"
import style0 from "./memberedit.vue?vue&type=style&index=0&id=a8996104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8996104",
  null
  
)

export default component.exports